import { FormsTable } from 'components';

export default function MyForms() {
  return <FormsTable persistentListParametersStateKey='myForms' title='My Forms' />;
}
